import {RootState} from './interfaces'

export const voucherSelector = (state: RootState) => state.voucher
